var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"brands"},[_c('h2',[_vm._v("Marcas Asociadas")]),_vm._l((_vm.brands),function(brand,index){return _c('a',{staticClass:"brand",attrs:{"href":brand.url}},[_c('img',{attrs:{"src":brand.logo,"alt":brand.name}})])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }